<template>
  <div class="fts-dropdown">
    <!-- <pre>
      formData.{{item.fieldName}}: {{formData[item.fieldName]}}
      formData.{{item.fieldName}}Id: {{formData[`${item.fieldName}Id`]}}
      [item]   type: {{item.type}}
      [item]   input(deprecated): {{item.input}}
      [props]  multiple: {{multiple}}
      [item]   connectionId: {{item.connectionId}}
      [item]   key: {{item.key}}
      [comp]   keyProperty: {{keyProperty}}
      [item]   keyProperty: {{item.keyProperty}}
      [props]  taggable: {{isTaggable}}
      [mthd]   label: {{label}}
      [item]   allowOther: {{item.allowOther}}
      [item]   canAddNew: {{item.canAddNew}}
      [item]   searchField: {{item.searchField}}
      [item]   displayProperty: {{item.displayProperty}}
      [item]   searchProperty: {{item.searchProperty}}
      [item]   reference: {{item.reference}}
    </pre> -->
    <v-select
      :append-to-body="appendToBody"
      :calculate-position="fitDropdownList"
      :label="label"
      :options="Array.isArray(list) ? list : []"
      :searchable="true"
      :filterable="true"
      :multiple="multiple"
      :text="formData[item.fieldName]"
      :taggable="isTaggable"
      :create-option="getCreateOption"
      :reduce="getReduce"
      :reduceKey="getReduceKey"
      :getOptionKey="getOptionKey"
      :getOptionLabelKey="getOptionLabelKey"
      :key-property="keyProperty"
      max-height="200px"
      :placeholder="multiple ? 'Please select' : 'Please select one'"
      v-model="formData[item.fieldName]"
      :with-color="withColor"
      :input-id="inputId"
      :select-on-tab="selectOnTab"
      :can-add-new="item.canAddNew"
      :connection-id="item.connectionId"
      :select-customize="selectOption && item.type != 24"
      :select-customize-display-name="item.displayName"
      :select-allow-customize="allowCustomize"
      :comfort-design="comfortDesign"
      :error="error"
      @addedNew="addedNew"
      @input="selectedOption => $emit('input', selectedOption)"
      @search="onSearch"
      @search:blur="$emit('blur')"
      @option:created="optionCreated"
      @option:selected="optionSelected"
      @option:deselected="optionDeselected"
      @option:cleared="optionCleared"
      ref="scroll"
    >
      <template #option="{ option, isTag}">
        <slot name="option" v-bind="option" :option="option">
          <template v-if="!selectOption">
            <span class="option--tag" v-if="isTag">custom</span>
            <template v-if="option && option.optionName">{{option.optionName}}</template>
            <template v-else-if="option && item.displayProperty">{{option[item.displayProperty]}}</template>
            <template v-else-if="option && option.name">{{option.name}}</template>
            <template v-else-if="option && option[label]">{{option[label]}}</template>
            <span class="undefined-option" v-else>(undefined)</span>
          </template>
        </slot>
      </template>
    </v-select>
  </div>
</template>

<script>
import axios from "axios";
import vSelect from "../vue-select/index";

import { classificationStore } from "../store/classificationStore";
import commons from "../commons/commons";

/*
 * SS06202 / SS06196 (ruled 2026-10-03): the open list of a dropdown appended to the body is not
 * pinned to the field. It is at least as wide as the field and grows to fit its options, up to
 * 480px and never past the viewport, and long options wrap inside it - so reading one no longer
 * means widening a table column.
 */
const LIST_MAX_WIDTH = 480;
const VIEWPORT_GUTTER = 16;

export function fitListWidth(fieldWidth, viewportWidth) {
  const field = Math.max(0, parseFloat(fieldWidth) || 0);
  const room = Math.max(0, (Number(viewportWidth) || LIST_MAX_WIDTH + VIEWPORT_GUTTER) - VIEWPORT_GUTTER);
  return {
    width: "max-content",
    minWidth: field + "px",
    maxWidth: Math.max(field, Math.min(LIST_MAX_WIDTH, room)) + "px",
  };
}

export default {
  props: {
    moduleId: [String, Number],
    moduleDesign: [String, Number],
    activityId: String,
    locusDetail: Boolean,
    locusId: {
      type: Number,
      default: null
    },
    appendToBody: {
      type: Boolean,
      default: true
    },
    multiple: Boolean,
    taggable: Boolean,
    allowCustomize: Boolean,   
    inputId: String,
    selectOnTab: Boolean,
    reduceKey: String,
    reduce: Function,
    observerHeight: Boolean,
    comfortDesign: Boolean,
    error: Boolean,
    item: Object,
    formData: Object
  },
  components: {
    "v-select": vSelect
  },
  data: () => ({
    searchAbortController: null,
    resizeObserver: null,
    list: []
  }),
  computed: {
    keyProperty() {
      if (this.item.keyProperty !== null && this.item.keyProperty !== undefined)
        return this.item.keyProperty;
      else if (this.item.searchProperty != null && this.item.searchProperty !== undefined)
        return this.item.searchProperty;  
      else if (this.item.reference)
        return "entityId";
      else
        return "id";
    },
    keyPropertyName() {
      if (this.item.key) {
        return this.item.key;
      }
      return `${this.item.fieldName}Id`;
    },
    label() {
      if (this.item.type == 24 || this.item.reference) {
        return "optionName";
      } else if (this.selectOption) {
        if (this.item.displayProperty) 
          return this.item.displayProperty;
        else
          return "name";
      } else if (this.item.connectionId) {
        if (this.item.searchField == "DocumentId") 
          return "documentId";
        else if (this.item.searchField)
          return `extension.${commons.camelize(this.item.searchField)}`;
        else if (this.item.type == 8)
          return "name";
        else
          return "value";
      } else if (this.item.displayProperty) {
        return this.item.displayProperty;
      } else {
        return "name";
      }
    },
    selectOption() {
      return (
        this.item.type == 24 ||
        this.item.type == 27 ||
        this.item.type == 28 ||
        this.item.input == 'select'
      );
    },
    withColor() {
      return (
        (
          this.item.type == 27 ||
          this.item.type == 28 ||
          this.item.input == 'select'
        ) &&
        !this.item.reference &&
        this.item.optionColor !== false
      );
    },
    getReduceKey() {
      if (this.reduceKey) {
        return this.reduceKey;
      } else if (this.item.reduceKey) {
        return this.item.reduceKey;
      } else if (this.item.displayProperty) {
        return this.item.displayProperty
      } else if (this.item.reference) {
        return 'optionName';
      } else if (this.item.type == 7) {
        if (
          this.item.valueTemplate !== null
          && this.item.valueTemplate !== undefined
          && this.item.valueTemplate !== ''
        )
          return 'value';
        else
          return 'optionName';
      } else if (this.item.type == 27 || this.item.type == 28) {
        return 'name';
      }
    },
    getReduce() {
      if (this.reduce && typeof this.reduce === 'function') {
        return this.reduce;
      } else if (this.item.reduce && typeof this.item.reduce === 'function') {
        return this.item.reduce;
      } else if (this.getReduceKey) {
        return x => x[this.getReduceKey];
      } else if (this.item.type == 8) {
        return x => ({ id: x.id, name: x.value });
      } else if (this.item.type == 24) {
        return x => ({ id: x.id, name: x.optionName });
      }
    },
    getOptionKey() {
      if (this.keyProperty && this.item.type !== 27 && this.item.type !== 28) {
        return x => {     
          try {
            if (typeof x !== 'object') {
              const valueId = this.formData[this.keyPropertyName];
              if (valueId) return valueId;
            }
   
            return x.hasOwnProperty(this.keyProperty)
              ? x[this.keyProperty] : x;
          } catch(err) {
            return console.warn('getOptionKey', x, err);
          }
        }
      }
    },
    getOptionLabelKey() {
      if (this.item.type === 8 || this.item.type === 24) {
        return 'name';
      }
    },
    getCreateOption() {
      if (this.item.type === 7)
        return x => ({ optionName: x, value: x, taggable: true });
      else if (this.item.type === 8)
        return x => ({ name: x, taggable: true });
      else if (this.item.type === 27 || this.item.type === 28)
        return x => ({ id: commons.newUUID(), name: x, color: null });
    },
    isTaggable() {
      if (this.item.type === 7 || this.item.type === 8)
        return this.item.allowOther;
      else if (this.item.type == 27 || this.item.type == 28)
        return this.item.taggable;
    },
    getModuleId() {
      if (this.moduleId)
        return this.moduleId;
      else if (classificationStore.state.vectorId)
        return classificationStore.state.vectorId;
      else if (this.item.connectionId)
        return this.item.connectionId;
    },
    getActivityId() {
      if (this.activityId)
        return this.activityId;
      else if (classificationStore.state.activityId)
        return classificationStore.state.activityId;
    }
  },
  methods: {
    // The select still places the list (Popper, drop-up); only the width it pinned changes.
    fitDropdownList(dropdownList, component, position) {
      const unbind = vSelect.props.calculatePosition.default.call(component, dropdownList, component, position);
      if (component.appendToBody) {
        Object.assign(dropdownList.style, fitListWidth(position && position.width, window.innerWidth));
        dropdownList.classList.add("fts-dropdown__menu--fit");
        if (component.popperInstance) component.popperInstance.update();
      }
      return unbind;
    },
    optionCreated(option) {
      this.item.optionList.push(option);
    },
    optionSelected(option) {
      if (this.keyProperty) {
        if (option.hasOwnProperty(this.keyProperty) && !this.multiple) {
          this.$set(this.formData, this.keyPropertyName, option[this.keyProperty]);
        } else if (this.formData[this.keyPropertyName]) {
          this.$delete(this.formData, this.keyPropertyName);
        }
      }
    },
    optionDeselected(option) {
    },
    optionCleared() {
      if (this.keyProperty) {
        if (this.formData[this.keyPropertyName])
          this.$delete(this.formData, this.keyPropertyName);
      }
    },
    getSearchData(vm) {
      let dataToPassIn = {};
      let lineDataToPassIn = {};
      let originalFormData = classificationStore.state.formData;

      if (vm.item.autoCompleteFormDataFields && originalFormData) {
        vm.item.autoCompleteFormDataFields.split(",").forEach(field => {
          dataToPassIn[field] = originalFormData[field];
          lineDataToPassIn[field] = vm.formData[field];
        });
      } else if (vm.item.filterFormula) {
        dataToPassIn = originalFormData;
        if (originalFormData != vm.formData) {
          lineDataToPassIn = vm.formData;
        }
      }

      return { dataToPassIn, lineDataToPassIn, originalFormData };
    },
    onSearch(search, loading, pageNumber, loadingMore) {
      if (this.$refs.scroll.open) {
        // if (this.item.optionList != null && (this.item.type == this.item.input == 'select' || this.item.connectionId == null || this.item.connectionId == 0) && !this.item.reference) {
        //   loading = false;
        //   this.list = this.item.optionList;
        // }
        if (
          (
            this.selectOption ||
            this.item.connectionId == null ||
            this.item.connectionId == 0
          ) && !this.item.reference && this.item.type != 24
        ) {
          loading = false;
          this.list = this.item.optionList;
        } else if (this.item.reference) {
          if (pageNumber == 0) {
            loading(true);
            this.list = [];
            this.search(loading, search, this, pageNumber, loadingMore);
          }
        } else {
          if (pageNumber == 0) {
            loading(true)
            this.list = [];
          } else {
            loadingMore(true);
          }
          this.search(loading, search, this, pageNumber, loadingMore);
        }
      }
    },
    search: _.debounce((loading, search, vm, pageNumber, loadingMore) => {
      var dataToPassIn = {},
        lineDataToPassIn = {};
      if (classificationStore) {
        let searchData = vm.getSearchData(vm);
        var originalFormData = searchData.originalFormData;
        dataToPassIn = searchData.dataToPassIn;
        lineDataToPassIn = searchData.lineDataToPassIn;

        var referenceModuleId = null;

        if (vm.item.reference && vm.item.referenceModuleField) {
          loadingMore(false);
          //pass in referene
          referenceModuleId =
            originalFormData[vm.item.referenceModuleField + "Id"];

          if (!referenceModuleId) {
            referenceModuleId =
              vm.formData[vm.item.referenceModuleField + "Id"];
          }
        }
      }

      if (vm.searchAbortController) {
        vm.searchAbortController.abort();
        vm.searchAbortController = null;
      }

      vm.searchAbortController = new AbortController();

      const queryPayload = {
        text: search,
        currentPage: pageNumber,
        pageSize: 10,
        fieldId: vm.item.id,
        x: vm.item.x,
        connectionId: vm.item.connectionId, // source module of the options — selection-cache invalidation tag
        activityId: vm.getActivityId,
        vectorId: vm.getModuleId,
        documentId: classificationStore.state.documentId,
        reference: referenceModuleId,
        locusId: vm.locusId,
        formData: dataToPassIn,
        data: lineDataToPassIn,
        moduleDesign: vm.moduleDesign,
        locusDetail: vm.locusDetail,
      };

      classificationStore.dispatch("searchEntry", { 
        data: queryPayload, 
        config: { signal: vm.searchAbortController.signal }
      }).then(
        res => {
          loading(false);
          loadingMore(false);

          if(res.data) {
            res.data.forEach(x => {
              if(x.format && x.optionName) {
                x.optionName = luxon
                  .fromISO(x.optionName)
                  .toFormat(
                    commons.dateFormatTranslate(x.format)
                  );
                x.value = x.optionName;
              }
            });
          }

          if (pageNumber == 0) {
            if (vm.$refs.scroll && vm.$refs.scroll.numberOfPageLoaded) {
              vm.$refs.scroll.numberOfPageLoaded = 0;
            }
            vm.list = res.data;
          } else {
            vm.list = vm.list.concat(res.data);
          }
        },
        error => {
          if (!axios.isCancel(error)) {
            loading(false);
            loadingMore(false);
            console.error(error);
            console.warn(
              "Got nothing from server. Prompt user to check internet connection and try again"
            );
          }
        }
      );
    }, 350),
    async addedNew(data) {
      try {
        const { dataToPassIn, lineDataToPassIn } = this.getSearchData(this);
        const res = await classificationStore.dispatch("searchEntry", {
          id: data.id,
          vectorId: this.getModuleId,
          activityId: this.getActivityId,
          fieldId: this.item.id,
          x: this.item.x,
          documentId: classificationStore.state.documentId,
          pageSize: 10,
          formData: dataToPassIn,
          data: lineDataToPassIn
        });

        if (res.data.length == 1) {
          const option = res.data[0];
          this.$set(this.formData, this.item.fieldName, (() => (this.getReduce)(option))());
          this.optionSelected(option);
        }
      } catch(err) {
        console.error(err);
        this.$toasted.global.error({ response: err.response });
      }
    },
    /* sync the displayed label from the key already held in formData (item.key) */
    syncLabelFromKey() {
      let vm = this;
      vm.list = vm.item.optionList;

      if (vm.item.key && vm.formData[vm.item.key] != null) {
        let optionMatched = vm.list.find(
          x => x[vm.keyProperty] == vm.formData[vm.item.key]
        );

        /*
          $set (not a plain assignment): this usually runs before the parent
          FTSFormElement has had a chance to seed the field, so a plain
          assignment would create a non-reactive property and every later
          selection would leave the displayed value stale (FETIAS Issue SS05796)
        */
        if (optionMatched)
          vm.$set(vm.formData, vm.item.fieldName, optionMatched[vm.label]);
      }
    },
  },
  watch: {
    "item.optionList": function() {
      this.syncLabelFromKey();
    }
  },
  mounted() {
    if (this.item.optionList) {
      this.syncLabelFromKey();
    }
    if (this.observerHeight && this.multiple) {
      this.resizeObserver = new ResizeObserver(_.debounce(entries => {
        try {
          const entry = entries.find(x => x.target ===this.$el);
          const elOffsetHeight = entry.target.offsetHeight;
          if (elOffsetHeight !== null && elOffsetHeight !== undefined) {
            this.$emit('updateHeight', `${elOffsetHeight}px`);
          }
        } catch(err) {
          console.warn("[DOMException]:ResizeObserver", err);
        }
      })); 
      this.resizeObserver.observe(this.$el);
    }
  },
  beforeDestroy() {
    if (this.resizeObserver) {
      this.resizeObserver.unobserve(this.$el);
      this.resizeObserver.disconnect();
    }
  },
};
</script>

<style lang="scss">
/* SS06202: a list sized by fitListWidth wraps a long option instead of cutting it off. The
   select's own (scoped) rules carry an attribute selector, so these out-rank them outright
   rather than winning on stylesheet order. */
.fts-dropdown__menu.fts-dropdown__menu--fit {
  li.fts-dropdown__option,
  li.fts-dropdown__option .fts-dropdown__option--custom .custom-tag {
    white-space: normal;
    overflow-wrap: anywhere;
  }
}
.undefined-option {
  font-style: italic;
  color: var(--fts-default);
}
.option--tag {
  margin-right: 0.25rem;
  padding-left: 0.125rem;
  padding-right: 0.125rem;
  border-radius: 0.125rem;
  background-color: var(--fts-secondary);
  color: var(--fts-light);
}
</style>
